module.exports = ".content-me {\n  background-color: lightcyan; }\n\n.content-you {\n  background-color: khaki; }\n"